import Eventbox from '/views/partials/eventbox/eventbox';

export default Eventbox;
